<template>
    <div class="option-banner mt-4 bg-white">
        <ul class="option-banner__list flex flex-wrap justify-between items-center">
            <li v-for="(item, index) in list" :key="index" class="option-banner__item h-full text-center">
                <a href="/" class="option-banner__item__link h-full flex flex-col justify-center items-center">
                    <div :style="url(item.url)" class="option-banner__item__img bg-cover my-4"></div>
                    <span class="option-banner__item__text flex-1 px-2 text-xl">{{ item.text }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'OptionBanner',
    setup() {
        const list = [
            {
                text: 'อิเล็กทรอนิกส์',
                url: 'https://cf.shopee.co.th/file/th-50009109-4aa07f992f58d87251a7e51db3704a2b_xhdpi'
            },
            {
                text: 'ลูกค้าใหม่ รับโค้ดหรือของขวัญ ฟรี',
                url: 'https://cf.shopee.co.th/file/th-50009109-c255b82019f4fa5b33da339d8d1f839d_xhdpi'
            },
            {
                text: 'ซูเปอร์มาร์เก็ตลดสูงสุด 80%',
                url: 'https://cf.shopee.co.th/file/th-50009109-d04a36aa08888fcfb5458c72f18d0c2b_xhdpi'
            },
            {
                text: 'เก็บคอยน์แลกโค้ด',
                url: 'https://cf.shopee.co.th/file/th-50009109-aeabf36909c9bb1f970de6685e73a602_xhdpi'
            },
            {
                text: 'ช้อปปี้โฮม',
                url: 'https://cf.shopee.co.th/file/th-50009109-dc9108f7d758ee297aab7157c96e5bb1_xhdpi'
            },
            {
                text: 'ช้อปปี้ถูกชัวร์',
                url: 'https://cf.shopee.co.th/file/th-50009109-f9fd64080005afb3a756f0e839a280c7_xhdpi'
            },
            {
                text: 'ส่งฟรี* + โค้ดลดทั้งแอป',
                url: 'https://cf.shopee.co.th/file/th-50009109-607eb78ad6e0d1a17034557ab06c7c8b_xhdpi'
            },
            {
                text: 'Shopee Choice ราคาโรงงาน',
                url: 'https://cf.shopee.co.th/file/th-11134258-7r98u-lwfn9z4ygc7jf7_xhdpi'
            },
            {
                text: 'Shopee Mall ลดสูงสุด 80%',
                url: 'https://cf.shopee.co.th/file/th-50009109-8cf66349bbda8240b0d881ddfb3216ff_xhdpi'
            },
            {
                text: '#ช้อปปี้ป้ายยา',
                url: 'https://cf.shopee.co.th/file/th-50009109-8a2c3e7771b852a7137b4bf4d0ca5f14_xhdpi'
            }
        ]

        return{
            list
        }
    },
    methods: {
        url: function(url){
            return `background-image: url(${url});`
        }
    }
}
</script>

<style scoped>
.option-banner__list{
    height: 10.8rem;
}

.option-banner__item{
    width: 10%;
    height: 10.8rem;
}

.option-banner__item__img{
    width: 4.5rem;
    height: 4.5rem;
}

@media (max-width: 1023px) {
    .option-banner__list{
        height: 10.8rem;
        justify-content: center;
        height: auto;
    }
    .option-banner__item{
        width: 15rem;
    }
}

</style>